import { render, staticRenderFns } from "./EmailReportConfig.vue?vue&type=template&id=6f060593&scoped=true&"
import script from "./EmailReportConfig.vue?vue&type=script&lang=js&"
export * from "./EmailReportConfig.vue?vue&type=script&lang=js&"
import style0 from "./EmailReportConfig.vue?vue&type=style&index=0&id=6f060593&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f060593",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCombobox } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCombobox,
  VFlex,
  VForm,
  VLayout,
  VSelect,
  VTextField,
})
